export default __webpack_public_path__ + "static/media/covid.ffe335c5.png";